import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import Admin from './Admin';
import Afiliado from './Afiliado';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/afiliado" element={<Afiliado />} />
        <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
